import { ArrowDropDown, Cancel } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { ReactElement, useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
    colorInput: {
        opacity: 0,
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        position: "absolute",
        cursor: "pointer",
    },
    icons: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
    },
    customIcons: {
        width: "fit-content",
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row"
    },
    container: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        position: "relative",
        width: "fit-content",
        pointerEvents: "all",
        padding: theme.spacing(1),
        color: "rgba(0, 0, 0, 0.42)",
        borderColor: "rgba(0, 0, 0, 0.12)",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "4px"
    },
    active: {
        backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
}));

interface Props
{
    value: string | null,
    onChange: (color: string | null) => void
    icon: ReactElement
}

export default function ColorInput({ icon, value, onChange }: Props)
{
    const classes = useStyles();

    const [colourValue, setColourValue] = useState(value);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    {
        setColourValue(event.currentTarget.value);
    }

    const clearValue = () =>
    {
        setColourValue(null);
        onChange(null);
    }

    useEffect(() =>
    {
        setColourValue(value);
    }, [value]);

    return <Box className={`${classes.container} ${colourValue ? classes.active : ""}`}>
        <Box className={classes.icons}>
            <Box className={classes.customIcons} sx={{ color: colourValue }}>
                {icon}{colourValue === null ? <ArrowDropDown fontSize="small" /> : null}
                <input type="color" value={colourValue ?? "#000000"} onChange={handleChange} onBlur={() => onChange(colourValue)} className={classes.colorInput} />
            </Box>
            <Box>{colourValue !== null ? <IconButton size={"small"} sx={{padding: "1px"}} onClick={clearValue}><Cancel fontSize="small" /></IconButton> : null}</Box>
        </Box>
    </Box>
}